import React, { Component } from 'react';
import { isEmpty, size } from "lodash";
import { Box, Typography, Dialog, DialogContent, IconButton, Table, TableBody, TableCell, TableRow, AppBar, Toolbar, TableHead, TableFooter, TablePagination  } from '@mui/material';
import Currency from '../../../common/Currency';
import StackedStats from '../../../Stats/StackedStats';

class EquipementStats extends Component {
    state = { 
        spendings: [],
        total: 0,
        totalDu: 0,
        selectedSpending: {}
    }
    componentDidMount = async () => {
        this.filterSpendings()
    }

    filterSpendings = () => {
        const { SPENDINGS, equipement, eType } = this.props;
        let filteredList = !isEmpty(SPENDINGS) ? Object.values(SPENDINGS).filter(item => item[`spending_${eType}`] === equipement.equipement_id) : []
        
        console.log('====================================');
        console.log({filteredList});
        console.log('====================================');
        let total = 0
        let totalDu = 0
        filteredList.forEach(item => {
            total += item.spending_amountTTC;
            totalDu += item.spending_rest_to_pay
        })

        this.setState({
            spendings: filteredList,
            total,
            totalDu,
        })
    }

    render() {
        const { spendings, totalDu} = this.state;
        return (
            <Box>
                <Box p={1}>
                    {/* Total: <Currency value={total} /> <br/> */}
                    Reste à Payer: <Currency value={totalDu} />
                    <StackedStats 
                        CATEGORIES={this.props.CATEGORIES.CHILD}
                        SPENDINGS={spendings}
                    />
                </Box>
            </Box>
                            
        );
    }
}

export default EquipementStats;